<template>
  <div>
    <!-- page-wrapper Start-->
    <div class="page-wrapper" id="canvas-bookmark">
      <!-- Page Header Start-->
      <div class="page-main-header" :class="{ open: toggle_sidebar_var }">
        <div class="main-header-right row">
          <div class="main-header-left col-auto px-0 d-lg-none">
            <div class="logo-wrapper"><router-link to="/"><img :src="mainHeaderLogoImageUrl"
              alt=""></router-link></div>
          </div>
          <div class="mobile-sidebar col-auto ps-0 d-block w-auto">
            <div class="flex-grow-1 text-end switch-sm">
              <label class="switch" v-on:click="toggle_sidebar">
                <vue-feather type="align-left"></vue-feather>
              </label>
            </div>
          </div>
          <div class="nav-right col p-0">
            <ul class="nav-menus" :class="{ open: mobile_toggle }">
              <li>
                
              </li>
              <li><a href="javascript:void(0)" class="text-dark" v-on:click="toggle_fullscreen()">
                  <vue-feather type="maximize"></vue-feather>
                </a>
              </li>
              <li class="onhover-dropdown">
                <div class="d-flex align-items-center"><img class="align-self-center pull-right img-50 rounded-circle"
                    :src="getImgUrl()" alt="header-user">
                </div>
                <ul class="profile-dropdown onhover-show-div p-20">
                  <li><a href="#" @click.prevent="goToEditProfile">
                      <vue-feather type="user"></vue-feather> Edit Profile
                    </a>
                  </li>
                  <li><a @click="logout">
                      <vue-feather type="log-out"></vue-feather> Logout
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <div class="d-lg-none mobile-toggle pull-right" v-on:click="mobile_toggle = !mobile_toggle">
              <vue-feather type="more-horizontal"></vue-feather>
            </div>
          </div>
        </div>
      </div>
      <!-- Page Header Ends -->
    </div>
  </div>
</template>
<script>
var body = document.getElementsByTagName("body")[0];
import { mapState } from "vuex";
import { clearStoredUserProfile, getStoredAvatarUrl, hydrateStoredUserProfile, resolveAvatarUrl } from "../utils/auth";
import { API_BASE } from "../config/api";
const DEFAULT_AVATAR = require("../assets/images/dashboard/user.png");
const DEFAULT_MAIN_LOGO = require("../assets/images/endless-logo.png");

export default {
  name: "HeaderSection",
  data() {
    return {
      terms: '',
      searchResult: false,
      searchResultEmpty: false,
      toggle_sidebar_var: false,
      clicked: false,
      toggle_rightsidebar_var: false,
      rightclicked: false,
      mobile_toggle: false,
      mobile_search: false,
      search: [],
      avatarUrl: getStoredAvatarUrl(),
      mainHeaderLogoUrl: '',
    }
  },
  computed: {
    ...mapState({
      menuItems: state => state.menu.data,
      langs: (state) => state.language.langs,
    }),
    mainHeaderLogoImageUrl() {
      if (!this.mainHeaderLogoUrl) {
        return DEFAULT_MAIN_LOGO;
      }

      if (this.mainHeaderLogoUrl.startsWith('http')) {
        return this.mainHeaderLogoUrl;
      }

      return `${API_BASE}${this.mainHeaderLogoUrl}`;
    },
  },
  methods: {
    getImgUrl() {
      return resolveAvatarUrl(this.avatarUrl, API_BASE) || DEFAULT_AVATAR;
    },
    async syncAvatarFromStorage() {
      await hydrateStoredUserProfile(API_BASE);
      this.avatarUrl = getStoredAvatarUrl();
    },
    async syncMainHeaderLogo() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.mainHeaderLogoUrl = '';
          return;
        }

        const response = await fetch(`${API_BASE}/api/System/main-header-logo`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        this.mainHeaderLogoUrl = data.logoUrl || '';
      } catch {
        // Keep default logo when settings endpoint is unavailable.
      }
    },
    searchTerm: function () {
      // this.$store.dispatch('menu/searchTerm', this.terms)
      let items = [];
      this.terms = this.terms.toLowerCase();
      this.menuItems.filter(menuItems => {
        if (menuItems.title.toLowerCase().includes(this.terms) && menuItems.type === 'link') {
          items.push(menuItems);
        }
        if (!menuItems.children) return false
        menuItems.children.filter(subItems => {
          if (subItems.title.toLowerCase().includes(this.terms) && subItems.type === 'link') {
            subItems.icon = menuItems.icon
            items.push(subItems);
          }
          if (!subItems.children) return false
          subItems.children.filter(suSubItems => {
            if (suSubItems.title.toLowerCase().includes(this.terms)) {
              suSubItems.icon = menuItems.icon
              items.push(suSubItems);
            }
          })
        })
        this.search = items
      });
    },

    logout: function () {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('Userinfo');
      clearStoredUserProfile();
      this.$router.replace('/auth/login');
    },
    goToEditProfile() {
      this.$router.push({ name: 'UserEditProfile' });
    },
    addFix() {

      this.searchResult = true;
    },
    removeFix() {
      this.searchResult = false;
      this.terms = ''
    },
    toggle_sidebar() {
      this.toggle_sidebar_var = !this.toggle_sidebar_var,
        this.clicked = !this.toggle_sidebar_var,
        this.$emit('clicked', this.clicked)
    },
    toggle_rightsidebar() {
      this.toggle_rightsidebar_var = !this.toggle_rightsidebar_var,
        this.rightclicked = !this.toggle_rightsidebar_var,
        this.$emit('rightclicked', this.rightclicked)
    },
    toggle_fullscreen() {
      if ((document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(language) {
      this.$i18n.locale = language
    },

  },
  mounted() {
    window.addEventListener('user-profile-updated', this.syncAvatarFromStorage);
    window.addEventListener('system-logo-updated', this.syncMainHeaderLogo);
    this.syncAvatarFromStorage();
    this.syncMainHeaderLogo();
  },
  unmounted() {
    window.removeEventListener('user-profile-updated', this.syncAvatarFromStorage);
    window.removeEventListener('system-logo-updated', this.syncMainHeaderLogo);
  },
  watch: {
    search: function () {
      this.terms ? this.addFix() : this.removeFix();
      if (!this.search.length)
        this.searchResultEmpty = true;
      else
        this.searchResultEmpty = false;
    }
  },

}
</script>
